import { CACHE_KEY } from '@constants/cacheKey';

import {
  CATEGORY_MAIN_PAGE_SIZE_MAX,
  requestCategoryMainAreaDetail,
  requestCategoryMainAreaList,
} from '@apis/renewal/categoryMain';
import type { CategoryMainPageKey } from '@apis/renewal/categoryMain';
import type {
  CornerAreaSource,
  CornerAreaSourceParams,
} from '@components/cornerArea/cornerAreaSource';
import DesktopSkeleton from '@components/pages/common/DesktopSkeleton';
import SubSkeleton03 from '@wconcept/wconcept-ui-renewal/components/molecules/_skeleton/SubSkeleton03';

interface CategoryMainSourceParam extends CornerAreaSourceParams {
  pageKey: CategoryMainPageKey;
  recommendItems?: string[];
  isMobile?: boolean;
}

/** 카테고리 메인 (/rn/category/{type}/{대분류}) 구좌 소스 */
export const createCategoryMainAreaSource = ({
  pageKey,
  recommendItems,
  displayDate,
  isMobile,
}: CategoryMainSourceParam): CornerAreaSource => ({
  listQueryKey: [
    CACHE_KEY.CATEGORY.CATEGORY_DISPLAY,
    pageKey.mediumCd,
    pageKey.categoryCd,
    displayDate ?? '',
  ],
  // 리스트 실패 시 빈 페이지로 처리 (LP 는 계속 노출)
  fetchList: pageNo =>
    requestCategoryMainAreaList(pageKey, {
      pageNo,
      pageSize: CATEGORY_MAIN_PAGE_SIZE_MAX,
      recommendItems,
      displayDate,
    }).catch(() => ({
      content: [],
      number: pageNo,
      totalPages: 0,
      totalElements: 0,
      size: 0,
      hasNext: false,
    })),
  detailScopeKey: [
    CACHE_KEY.CATEGORY.CATEGORY_DISPLAY_DETAIL,
    pageKey.mediumCd,
    pageKey.categoryCd,
    displayDate ?? '',
  ],
  fetchDetail: (area, params) =>
    requestCategoryMainAreaDetail(pageKey, area.areaSubType, area.id, {
      recommendItems,
      displayDate,
      ...params,
    }),
  skeleton: isMobile ? <SubSkeleton03 /> : <DesktopSkeleton />,
  attachDetails: true,
});
